import { HttpClient } from 'common/HttpClient'
import { Environment } from 'enviroment/AppSettings'
import { CodeSubmitAgainResponse } from './SmsCodeServiceProps'


export class SmsCodeService{
    private readonly _client : HttpClient
    private readonly _url = "smsCode";
    constructor(){
        this._client = new HttpClient(Environment.apiUrl);
    }
    
    public async submitAgainSmsCode(): Promise<CodeSubmitAgainResponse>{
        const url = `${this._url}`;
        const response = await this._client.get<CodeSubmitAgainResponse>(url, true);
        return response.data;
    }
}